import { LocalStorage } from "components/appModules/LocalStorage";
import { Component, ComponentDefinition } from "components/components/Component";
import sislogUserGlobals from "components/UserGlobals";
import $ from "jquery";
import { IndexHeader } from "pages/index/IndexHeader";
import template from "./index.hbs";
import "./index.scss";

export class Index implements Component {
    public componentType = "pages.indexPage";
    public definition: ComponentDefinition;
    public id;
    private view: Element;

    constructor(schema) {
        this.definition = schema;
    }

    public render() {
        let attr = {} as any;
        if (LocalStorage.getUid() != null) {
            attr.uid = LocalStorage.getUid();
            attr.login = LocalStorage.getLogin();
            attr.userName = LocalStorage.getUsername();
            attr.showLogin = (attr.login !== attr.userName);
        }
        attr.appEnvironment = sislogUserGlobals.appEnvironment;
        let appConfig = window["sislog6AppConfig"];
        if (appConfig.notificationsUrl != null) {
            attr.notificationsUrl = appConfig.notificationsUrl;
        }
        if (appConfig.helpUrl != null) {
            attr.helpUrl = appConfig.helpUrl;
        }
        if (this.isLDS() || document["s6_build_id"] === "versionDesarrollo") {
            attr.s6_build_id = document["s6_build_id"];
        }
        let view = $(template(attr));
        this.view = view[0];
        IndexHeader.instance.init(this.view.getElementsByClassName("c-main-page__header")[0]);
        // TODO do not redraw if it is already the correct one
        IndexHeader.instance.updateHeader(this.view.querySelector(".c-main-page__sidebar-menu"));

        this.view.getElementsByClassName("c-main-page__min-tack")[0].addEventListener("click", (evt) => {
            let list_link_a = $("*[class^='c-menu-parent-node__level-']").not(".c-menu-parent-node__a--hidden")
            if (list_link_a != null && list_link_a.length > 0) {
                for (var i = 0; i < list_link_a.length; i++) {
                    list_link_a[i].classList.toggle("c-menu-parent-node__a--hidden", true);
                }
            }
            let list_link_div = $(".c-menu-parent-node__children").not(".c-menu-parent-node__children--hidden");
            if (list_link_div != null && list_link_div.length > 0) {
                for (var i = 0; i < list_link_div.length; i++) {
                    list_link_div[i].classList.toggle("c-menu-parent-node__children--hidden", true);
                }
            }
        });

        return this.view;
    }

    public static default() {
        let definition = {
            name: "index",
            componentType: "pages.indexPage",
            children: [
            ],
        };
        return new Index(definition);
    }

    private isLDS() {
        return window.location.href.includes("#!/lds/");
    }
}
